<script setup>
import {computed, onMounted, ref} from "vue";
import {useStore} from "vuex";

import InstallationInfo from "@/components/onsiteEditor/components/installation/InstallationInfo.vue";
import InstallationPanel from "@/components/onsiteEditor/components/installation/InstallationPanel.vue";
import VideoIframe from "@/components/video/VideoIframe.vue";
import AssistedInstallation from "@/components/onsiteEditor/components/installation/AssistedInstallation.vue";

const props = defineProps({
  isOnboarding: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const store = useStore();

onMounted(() => {
    store.dispatch('user/getUser');
    store.dispatch('onsiteEditorInstallation/fetchInstallationOptions');
});

const panels = {
  InstallationInfo,
  InstallationPanel,
  AssistedInstallation,
};

let currentStep = ref('InstallationInfo');
const currentProps = computed(() => {
  if (currentStep.value === 'InstallationPanel') {
    return {
      isOnboarding: props.isOnboarding,
    };
  }

  return {};
});

const videoUrl = computed(() => {
    if (currentStep.value === 'InstallationInfo') {
      return 'https://player.vimeo.com/video/929844758?h=4363ad5cae&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479';
    }

    return store.getters['onsiteEditorInstallation/installation'].find(
        instructions => instructions.value === store.getters['onsiteEditorInstallation/activeFilter']
    )?.videoUrl ?? false;
});

</script>

<template>
  <div class="tailwind">
    <div class="tw-mx-auto tw-flex tw-max-w-8xl tw-flex-col tw-leading-6">
      <div
        v-if="isOnboarding"
        class="tw-pb-8 tw-pt-3.5 tw-text-4.5xl tw-font-bold tw-leading-5 tw-tracking-tighter tw-text-slate-100"
      >
        4. Install the Onsite Optimizer Pixel
      </div>
      <component
        :is="panels[currentStep]"
        v-bind="currentProps"
        :show-video="!!videoUrl"
        @next-step="() => currentStep = 'InstallationPanel'"
        @go-to-assisted="() => currentStep = 'AssistedInstallation'"
        @back="() => currentStep = 'InstallationInfo'"
      >
        <VideoIframe
          v-if="videoUrl"
          :video-url="videoUrl"
          class="tw-h-[22.93213rem] tw-w-[40.625rem] tw-rounded-[8px]"
        />
      </component>
    </div>
  </div>
</template>
